<template>
  <v-card>
    <div class="d-flex flex-no-wrap justify-space-between">
      <v-avatar class="ma-3" size="100" tile>
        <v-img contain scale="1" :src="getImageURL(url, producto.image)">
        </v-img>
      </v-avatar>

      <div style="width: 525px">
        <v-card-title class="headline" v-text="producto.description">
        </v-card-title>

        <v-card-subtitle class="py-0">
          Risoul #:{{ producto.code }}
        </v-card-subtitle>
        <v-card-subtitle class="py-0">
          Parte #:{{ producto.providerCode }}
        </v-card-subtitle>

        <v-card-subtitle v-if="isClient" class="py-0 precio">
          <precioBtn
            :clientId="client.clientId"
            :unitType="producto.unit"
            :itemId="producto.itemId"
            :isProductDetail="false"
          >
          </precioBtn>
        </v-card-subtitle>
        <!-- <v-card-subtitle v-text="product.description"></v-card-subtitle> -->
      </div>

      <v-spacer></v-spacer>

      <div class="counterClass">
        <!-- Botones del contador -->
        <div class="counterInline">
          <div class="counterText">
            <!-- TextField cantidad -->
            <v-text-field
              v-if="!selectVisible"
              hide-details
              reverse
              @blur="updateLocalStorage(producto.quantity)"
              @keypress="allowOnlyNumbers"
              class="order-cant"
              v-model="producto.quantity"
              :value="producto.quantity"
              solo
              dense
              type="text"
            >
            </v-text-field>

            <v-select
              v-if="selectVisible"
              solo
              hide-details
              dense
              v-model="producto.quantity"
              :items="cantidad"
              @change="updateLocalStorage(producto.quantity)"
            >
            </v-select>
          </div>

          <!-- Botón de eliminar producto -->
          <div class="deleteButton">
            <v-dialog v-model="dialog" max-width="600" persistent>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text color="red darken-1" dark v-bind="attrs" v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar color="primary" dark>
                  ¿Estas seguro de eliminar el siguiente artículo?
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text>
                  <div class="d-flex flex-no-wrap">
                    <v-avatar class="ma-3" size="100" tile>
                      <v-img
                        contain
                        scale="1"
                        :src="getImageURL(url, producto.image)"
                      >
                      </v-img>
                    </v-avatar>

                    <div>
                      <v-card-title
                        class="headline"
                        v-text="producto.description"
                      >
                      </v-card-title>

                      <v-card-subtitle class="py-0">
                        Risoul #:{{ producto.code }}
                      </v-card-subtitle>
                      <v-card-subtitle class="py-0">
                        Parte #:{{ producto.providerCode }}
                      </v-card-subtitle>
                      <!-- <v-card-subtitle v-text="product.description"></v-card-subtitle>
                      <v-card-subtitle v-text="product.description"></v-card-subtitle> -->
                    </div>
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-btn color="red darken-1" text @click="cancelDelete()">
                    Cancelar
                  </v-btn>
                  <v-btn color="primary" text @click="deleteItem()">
                    Aceptar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

          <div class="">
            <v-card-subtitle class="disclamerText stock">
              <existenciasBtn
                :isDetail="false"
                :itemId="producto.itemId"
                :snackbar="snackbar"
              >
              </existenciasBtn>

              <br />
              Stock salvo previa venta.
            </v-card-subtitle>
          </div>
        </div>

        <div class="counterInline"></div>
      </div>
    </div>
  </v-card>
</template>

<script>
import _ from "underscore";
import existenciasBtn from "../child_btn_existencias.vue";
import precioBtn from "../child_btn_precio.vue";
import { getImageURL } from "../../utils/shoppingCart";

export default {
  components: {
    existenciasBtn,
    precioBtn,
  },

  data() {
    return {
      client: "",
      isClient: false,
      selectVisible: true,
      cantidad: [
        { text: "0 (Eliminar)", value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 },
        { text: "9", value: 9 },
        { text: "10+", value: 10 },
      ],
      interval: false,
      dialog: false,
      getImageURL,
      url: "https://risoulimages.s3-us-west-2.amazonaws.com/Imagenes+Items/Imagenes/",
      itemId: "",
    };
  },

  props: {
    producto: { type: Object },
    updateShopingQuantity: { type: Function },
    actualizarContadores: { type: Function },
    snackbar: { type: Function },
  },

  methods: {
    getPrecio: async function ({ itemId }, { clientId }) {
      var elPrecio;
      let price;
      let res = await this.$http({
        method: "get",
        url: `https://market.risoul.com.mx/api/product/precioMoneda/${itemId}/${clientId}`,
      });

      if (res.status == 200) {
        price = res.body;
        let precio =
          typeof price.precio == "Number"
            ? Math.round(price.precio * 100) / 100
            : price.precio;
        let moneda =
          price.moneda == "pesos" || price.moneda == "Pesos"
            ? "MXN"
            : price.moneda;
        elPrecio =
          res.body.precio == 0
            ? "Agregarlo a lista para su cotización"
            : `$ ${precio} ${moneda}`;
      } else {
        this.snackbar(`Hubo un problema al obtener la precio del producto`);
      }
      return elPrecio;
    },

    deleteItem: function () {
      var vm = this;
      var shoppingCart = JSON.parse(localStorage.getItem("shoppingCart")),
        shoppingCart = _.filter(shoppingCart, (item) => {
          return item.id !== vm.producto.id;
        });
      localStorage.setItem("shoppingCart", JSON.stringify(shoppingCart));
      this.dialog = false;
      vm.updateShopingQuantity();
      vm.actualizarContadores();
    },

    addItem: function () {
      var vm = this;
      if (!vm.interval) {
        vm.interval = setInterval(
          () => (vm.producto.quantity = Number(vm.producto.quantity) + 1),
          60,
        );
      }
    },

    removeItem: function () {
      var vm = this;
      if (Number(vm.producto.quantity) == 1) return;
      if (!this.interval) {
        this.interval = setInterval(
          () =>
            Number(vm.producto.quantity) > 1
              ? (vm.producto.quantity = Number(vm.producto.quantity) - 1)
              : (vm.producto.quantity = 1),
          70,
        );
      }
    },

    stop() {
      var vm = this;
      clearInterval(vm.interval);
      vm.interval = false;
      vm.updateLocalStorage();
    },

    allowOnlyNumbers(event) {
      const key = event.key;
      if (!/^[0-9]$/.test(key)) {
        event.preventDefault();
      }
    },

    updateLocalStorage: function (cantidad) {
      var vm = this;
      vm.producto.quantity = Number(cantidad);
      if (cantidad == 0) {
        vm.dialog = true;
      }
      if (cantidad == 10) {
        vm.producto.quantity = 10;
        vm.selectVisible = false;
      }
      if (cantidad > 0 && cantidad < 10) {
        vm.selectVisible = true;
      }

      var products = JSON.parse(localStorage.getItem("shoppingCart"));
      const newState = products.map((updated) =>
        updated.id === vm.producto.id
          ? { ...updated, quantity: vm.producto.quantity }
          : updated,
      );
      localStorage.setItem("shoppingCart", JSON.stringify(newState));
      vm.updateShopingQuantity();
      vm.actualizarContadores();
    },

    cancelDelete: function () {
      var vm = this;

      vm.producto.quantity =
        vm.producto.quantity == 0 || vm.producto.quantity == "0 (Eliminar)"
          ? 1
          : vm.producto.quantity;
      vm.selectVisible = vm.producto.quantity < 10;
      vm.dialog = false;
    },
  },

  computed: {},

  watch: {},

  created() {
    this.client = JSON.parse(localStorage.getItem("clientId"));

    this.isClient = !!this.client;
  },

  mounted() {
    var vm = this;
    vm.selectVisible = vm.producto.quantity < 10;
  },
};
</script>

<style lang="scss" scoped>
.counterClass {
  max-width: 20rem;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  margin: 6px 0;
}

.counterInline {
  max-width: 20rem;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.counterText {
  padding: 0 0.5rem 0 0.5rem;
  width: 100px;
}

.counterButton {
  width: 35px;
}

.v-toolbar {
  font-size: 1.6rem;
  font-weight: 400;
}

.v-dialog > .v-card > .v-card__text {
  padding: 8px 4px;
}

.precio {
  color: #fa6b17 !important;
  font-size: 14px;
  font-weight: 500;
}
</style>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.disclamerText {
  font-size: 14px;
  margin: 4px 0 !important;
  padding: 0;
}
</style>
